import { Injectable } from '@angular/core';
import { SETTINGS } from '../configs/common.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private http: HttpClient) {}

  createProject(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/project/create`, payload);
  }

  updateProject(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/project/update`, payload);
  }

  getProjectsOptions(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/project/get-options`);
  }

  getProjectsByClient(clientId: any): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/project/get-all-by-client/${clientId}`
    );
  }

    getProjectById(Id: any): Observable<any> {
        return this.http.get(
            `${SETTINGS.BASE_API}/project/get/${Id}`
        );
    }

  deleteProject(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/project/delete`, payload);
  }
}
